/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b92d5eaec4aa39e36df798a65b362b50>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ShrinkVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ShrinkVerticalIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "ShrinkVerticalIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 9.75V16h-1.5V9.75zm-1.5-3.5V0h1.5v6.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m8 10.81-2.97 2.97-1.06-1.06 3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06zm-.53-4.03-3.5-3.5 1.06-1.06L8 5.19l2.97-2.97 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ShrinkVerticalIcon.displayName = 'ShrinkVerticalIcon';
var _default = exports.default = ShrinkVerticalIcon;